import router from '@/router'

export function useTariffUpgrade() {
    return {
        openUpgrade(context) { // eslint-disable-line no-unused-vars -- context kept in the public signature for future use
            if (router.currentRoute.value.path !== '/tariffs') {
                router.push('/tariffs')
            }
        },
    }
}
